import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <h2 className="about-title">About Aesthetic AI Receptionist</h2>
        
        <div className="about-content">          <div className="founder-image">
            <div className="founder-photo">
              <div className="placeholder-image">
                <div className="placeholder-icon">👨‍⚕️</div>
                <div className="placeholder-text">Doctor George</div>
              </div>
            </div>
          </div>
          
          <div className="about-text">
            <p className="about-description">
              Aesthetic AI Receptionist streamlines the 
              process of scheduling visits with specialists. Our solution 
              ensures efficient and accessible appointment bookings, tailored to 
              each patient's needs.
            </p>
            
            <p className="about-description">
              By automating administrative tasks, Aesthetic AI Receptionist enhances the 
              coordination of aesthetic clinic care, allowing practices to focus on delivering 
              exceptional services. Our platform is a leap towards improved patient 
              experience and operational efficiency.
            </p>
            
            <div className="founder-info">
              <h3 className="founder-name">Doctor George</h3>
              <p className="founder-title">Founder of Aesthetic AI Receptionist</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
